// extracted by mini-css-extract-plugin
export var base = "_48-0";
export var updateBanner = "_48-1";